import {PanelBase} from "./panelBase";
import {Integrations} from "../integrations";
import * as BootstrapModal from "@/shared/ui/bootstrapModal";
import {IntegrationType} from "@/shared/timrTypes";

export class CustomIntegration extends PanelBase {

	constructor() {
		super();
	}

	// Called when the element is inserted in the DOM
	// DEVNOTE: No shadow DOM here, so we can use external css
	private connectedCallback() {
		this.innerHTML = this.renderPanel({
			logoHtml: `<img src="/timr/images/integrations/custom.svg" alt="Custom" height="36px">`
		});
		this.initListeners();
	}

	private initListeners() {
		this.querySelector("[data-delete-integration]").addEventListener("click", () => {
			BootstrapModal.confirm({
				title: messages["dialog.delete.confirm"],
				message: messages["integrations.custom.delete.message"],
				yesAction: (confirmModal) => {
					confirmModal.close();
					Integrations.triggerDeletedIntegrationEvent(IntegrationType.CUSTOM, this.integration.id);
				}
			});
		});
	}

	protected updateBanner(): void {
		// Nothing to do here
	}

	public onIntegrationAdded() {
		// Nothing to do here
	}
}
